import React from "react";
import Region from "../region";
import Loader from "../loader";
import Config from "../../../config/main";

export default function regionsListTemplate() {
	let { data, loaded, selectorKey, sportAlias, gameType } = this.props;
	if (data && loaded) {
		return (
			<div
				className={`region-list ${
					Config.main.hasDayFilter && window.location.pathname.includes("prematch")
						? "day-filter"
						: ""
				}`}
			>
				<ul className={sportAlias} ref={el => (this.scrollerRegions = el)}>
					{data.regionIds.map(regionId => {
						return (
							<Region
								key={regionId}
								regionId={regionId}
								selectorKey={selectorKey}
								sportAlias={sportAlias}
								gameType={gameType}
							/>
						);
					})}
				</ul>
				<div className="scroll-b-view-w">
					<div className="single-s-b top-v" onClick={this.scroll(-150)} />
					<div className="single-s-b bot-v" onClick={this.scroll(150)} />
				</div>
			</div>
		);
	} else {
		return <Loader component="regionsList" withoutMessage={true} />;
	}
}
